import { Fragment, type ReactNode } from "react";

/**
 * An email as text that a narrow cell may break only after its `@` and before each `.`, never in
 * the middle of a word (`daniil@` / `ejam` / `.com`; spec ui-perf/pro-polish-manage). Its text is
 * the email itself: the breaks are `<wbr>`, which add no characters.
 */
export function breakableEmail(email: string): ReactNode {
  const parts = email.split(/(?<=@)|(?=\.)/);
  return parts.map((part, index) => (
    <Fragment key={index}>
      {index === 0 ? null : <wbr />}
      {part}
    </Fragment>
  ));
}
